import { FONT_SIZE, OTHER_CONSTANTS, THEME_COLORS } from "../styles";
import { FontAwesome as Icon } from "@expo/vector-icons";
import { StyleSheet, Text, View } from "react-native";
import React from "react";

interface IGetApprovalVerificationStatusProps {
  approvalStatus: string;
  verification: string;
}

export const GetApprovalVerificationStatus = (
  props: IGetApprovalVerificationStatusProps
) => {
  const APPROVAL_TYPE = "APPROVAL";
  const VERIFICATION_TYPE = "VERIFICATION";
  const VERIFIED = "VERIFIED";
  const APPROVED = "APPROVED";
  const DISCARDED = "DISCARDED";
  const REJECTED = "REJECTED";
  const getText = (status, type) => {
    let styledText =
      type === APPROVAL_TYPE ? "Approval Pending" : "Verification Pending";
    let iconColor = THEME_COLORS.black2;
    let iconName = "circle";
    if (status === APPROVED) {
      iconColor = THEME_COLORS.success;
      styledText = "Approved";
      iconName = "check";
    } else if (status === VERIFIED) {
      styledText = "Verified";
      iconColor = THEME_COLORS.success;
      iconName = "check";
    } else if (status === DISCARDED) {
      type === APPROVAL_TYPE
        ? (styledText = "Approval Rejected")
        : (styledText = "Verification Rejected");
      iconColor = THEME_COLORS.redAlert;
      iconName = "ban";
    } else if (status === REJECTED) {
      iconColor = THEME_COLORS.warning;
      iconName = "times-circle-o";
      type === APPROVAL_TYPE
        ? (styledText = "Not Approved")
        : (styledText = "Not Verified");
    }

    return (
      <>
        <Icon
          style={[styles.cursorPointer, { marginHorizontal: 4 }]}
          name={iconName}
          color={iconColor}
          size={15}
        />
        <Text
          style={[
            {
              color: iconColor,
              fontSize: 12,
              fontWeight: "bold",
              marginHorizontal: 3,
            },
          ]}
        >
          {styledText}
        </Text>
      </>
    );
  };
  const { approvalStatus, verification } = props;
  const isVerificationApplicable = approvalStatus === APPROVED;
  return (
    <View style={[styles.columnPadding, styles.justifyContentCenter]}>
      <View style={[styles.row, { alignItems: "center" }]}>
        {!!approvalStatus ? getText(approvalStatus, APPROVAL_TYPE) : null}
      </View>
      <View style={[styles.row, { alignItems: "center" }]}>
        {isVerificationApplicable
          ? getText(verification, VERIFICATION_TYPE)
          : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flex: 1,
    flexDirection: "row",
  },
  justifyContentCenter: {
    justifyContent: "center",
  },
  columnPadding: {
    padding: 5,
    flex: 1,
  },
  cursorPointer: {
    cursor: "pointer",
  },
});
